import Link from "next/link";

// Candidate practice pages. They stay live for search but sit outside the B2B
// nav; this banner routes hiring-side visitors back to the platform.
const layout = ({ children }) => {
    return (
        <section className="relative isolate overflow-hidden bg-white pt-[120px]">
            <div className="max-w-5xl mx-auto px-6 mb-8">
                <div className="flex flex-col sm:flex-row items-center justify-center gap-2 rounded-xl border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-gray-700 text-center">
                    <span>Hiring at scale? AI Interview Agents runs first-round interviews for hiring teams.</span>
                    <Link href="/" className="font-semibold text-blue-600 hover:underline whitespace-nowrap">
                        See the platform →
                    </Link>
                </div>
            </div>
            {children}
        </section>
    )
}

export default layout
